/*
 * Copyright notice
 *
 * (c) 2022 Daniel Kruse <d.kruse@atlantisdx.de>, atlantis dx GmbH
 *
 * All rights reserved
 *
 *  This script is part of the TYPO3 project. The TYPO3 project is
 *  free software; you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation; either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  The GNU General Public License can be found at
 *  http://www.gnu.org/copyleft/gpl.html.
 *
 *  This script is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 * This copyright notice MUST APPEAR in all copies of the script!
 */
import $ from 'jquery';
import 'jquery-validation';
import 'jquery-validation/dist/localization/messages_de';

if ($.validator) {
	// Validator setup
	$.validator.setDefaults({
		errorClass: 'error-label',
		/**
		 *
		 * @param error
		 * @param element
		 */
		errorPlacement: (error, element) => {
			if ($(element).is('select')) {
				$(element).closest('.sel').addClass('f3-form-error');
				error.appendTo(element.closest('.form-group'));
			} else if ($(element).is(':checkbox')) {
				error.appendTo(element.parent().parent());
			} else {
				error.appendTo(element.parent());
			}
		},
		/**
		 *
		 * @param element
		 */
		highlight: (element) => {
			$(element).addClass('f3-form-error-highlight');
		},
		/**
		 *
		 * @param element
		 */
		unhighlight: (element) => {
			$(element).removeClass('f3-form-error-highlight');
			$(element).parent().find('.error-label').hide();
		},
	});

	/** General Validation **/
	$('.atl-form').validate({});
}
